import React, { useEffect } from "react"
import { Container, Row, Col, Button } from "reactstrap"
import * as s from "./style.module.css"
import Dots from "../Dots/index"
import useLabels from "../../utils/useLabels"

import labels from "../Summary2025/const"
import Numbers from "../Numbers"
import Text from "../Text"
import Workshops, { Workshop } from "../Workshops"
import Mentors from "../Mentors"
import Partners, { PartnersCard } from "../Partners"
import WorkshopsFull from "../WorkshopsFullDesc"
import MentorsFull from "../MentorsWithDesc"
import Gadget from "../Gadget"
import Localization from "../Localization"
import Idea from "../Idea"

export default function Summary2025({ lang }) {
  const t = useLabels(labels, lang)

  return (
    <div className={s.root}>

    <Idea type="animatonSumm" isReverse/>

      <Container className="mb-5">


        {/* Projects section */}
        <div className="mt-5">
          <div className={s.header}>
            <h2>{t.projects2024.projectsTitle}</h2>
            <div className={s.divider} />
          </div>

          <p
            className={s.summaryText}
            dangerouslySetInnerHTML={{ __html: t.projects2024.summary }}
          />
        </div>

      </Container>

      <div className={[s.bgWrapper, "px-5"].join(" ")}>
        <div className="position-relative">
          <Col>
            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">
               
                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.winners.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.winners.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.winners.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.winners.text }}
                  />
                </div>
              </div>
            </div>
            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">
              
                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.winners2.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.winners2.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.winners2.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.winners2.text }}
                  />
                </div>
              </div>
            </div>

              <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">
              
                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2024.winners3.name}</h1>
                  <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2024.winners3.image} />
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2024.winners3.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2024.winners3.text }}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Row xs={1} md={2} className="justify-content-center">
            {t.projects2024.projects.map(project => (
              <Col className="mb-4">
                <Project {...project} />
              </Col>
            ))}
          </Row>
        </div>
      </div>

      <section id="workshop-2025">
        <WorkshopsFull workshops={t.workshops2025} />
      </section>

      <section id="mentors-2025">
        <MentorsFull mentors={t.mentors2025} />
      </section>

      <section id="partners-2025">
        <div className={s.root}>
          <Container className={s.container}>

             <div className={s.header}>
                    <h2 className={s.partnersTitle}>{t.partners2025.organizers.title}</h2>
                    <img
                        className={s.line}
                        src={require("../Text/icons/line.svg").default}
                      />
            
                      {t.partners2025.organizers.logos.map(({ title, elements }) => (
                        <PartnersCard title={title} elements={elements} />
                      ))}
                    </div>
            
            
                    <div className={s.header}>
                      <h2 className={s.partnersTitle}>{t.partners2025.title}</h2>
                      <img
                        className={s.line}
                        src={require("../Text/icons/line.svg").default}
                      />
            
                      {t.partners2025.partners.logos.map(({ title, elements }) => (
                        <PartnersCard title={title} elements={elements} />
                      ))}
                    </div>
          </Container>
        </div>
      </section>

    </div>
  )
}

function Project({ text, name, image, place, posX, posY }) {
  const dostStyle = {
    position: "absolute",
    top: posX,
    left: posY,
    transform: "scale(1.6)",
    zIndex: 0
  }


  return (
    <div
      className={[s.project, s.highlight].join(" ")}
    >
      <div className="d-flex">
      </div>

      <h4 className={s.projectTitle}>{name}</h4>
      {image &&
        <div className={s.imgWrapper}>
            <img alt="" className={s.img} src={image} />
            {/*<div style={dostStyle}>*/}
            {/*  <Dots x={4} y={4} color="black" />*/}
            {/*</div>*/}
        </div>
        }
      <h5 className={s.place}>{place}</h5>
      <p className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  )
}
